<template>
  <div>
    <ul class="ul2 style1" v-if="collectList && collectList.length > 0">
      <router-link :to="items.url" tag="li" v-for="(items, child) in collectList" :key="child">
        <div class="imgbox" v-if="items.image">
          <img class="imgtop" :src="items.image" alt="">
        </div>
        <div class="txtbox">
          <h2 class="textover">{{ items.title }}</h2>
          <el-button type="text"><i class="el-icon-right"></i>查看详情</el-button>
        </div>
      </router-link>
    </ul>
    <el-empty v-if="collectList && collectList.length === 0" description="您还未有收藏内容"></el-empty>
    <el-pagination
      @current-change="handleCollectCurrentChange"
      :page-size="collectParams.limit"
      :pager-count="5"
      :current-page.sync="collectParams.currentPage"
      layout="prev, pager, next"
      :total="collectTotal"
      class="pagemodel1">
    </el-pagination>
  </div>
</template>

<script>
import { getusercollect } from '@/api/user/index'
import { scrollAnimation } from '@/utils/index'
import nodata from '@/components/nodata/index'
export default {
  name: 'usercollect',
  components: {
    nodata
  },
  data () {
    return {
      collectParams: {
        fid: this.$cookie.get('culturalCloud_fid'),
        webUserId: this.$cookie.get('wlymobilephone'),
        menuId: '',
        page: 1,
        limit: 10,
        currentPage: 1
      },
      collectTotal: 0,
      collectList: []
    }
  },
  mounted () {
    this.usercollect()
  },
  methods: {
    /* 我的收藏 */
    usercollect () {
      getusercollect(this.collectParams).then((res) => {
        // console.log(res)
        this.collectList = res.data.data.rows
        this.collectTotal = res.data.data.total
      })
    },
    /* 收藏分页 */
    handleCollectCurrentChange (val) {
      this.collectParams.page = val
      const currentY = document.documentElement.scrollTop || document.body.scrollTop
      scrollAnimation(currentY, 0)
      this.usercollect()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/common/scss/user.scss";
</style>



// WEBPACK FOOTER //
// src/view/personalcenter/usercollect.vue